import React from 'react';
import ProductSlider from './ProductSlider';
import useFetch from '../hooks/useFetch.js';

const LatestProducts = () => {
  // get new products
  const { data } = useFetch('/products');

  return (
    <div className='my-16'>
      <div className='container mx-auto'>
        <h2 className='h2 mb-6 text-center xl:text-left'>Хит продукты</h2>
         <ProductSlider data={data} />
      </div>
    </div>
  );
};

export default LatestProducts;
